<div id="search-container-id" class="document-search-cdn-govco search-principal-govco">
  <div class="bar-search-govco {{activo}} {{existContent}}">
    <input type="text" id="inputSearchGeneral" aria-label="Buscador por componente" [(ngModel)]="textSearch" 
      placeholder="Buscar por componente" class="input-search-cdn-govco text-2" (keyup)="searchComponent($event)"/>
    <button class="icon-search-govco icon-close-search-govco govco-svg govco-times" aria-label="Eliminar búsqueda"></button>
    <div class="icon-search-govco search-icon-search-govco" aria-hidden="true"></div>
  </div>
  <div id="container-options-search-general" class="container-options-search-cdn-govco">
    <div class="no-result" *ngIf="listado.length == 0">
      <span role="status" aria-live="polite">No se encontraron resultados</span>
    </div>
    <div class="options-search-govco" *ngIf="listado.length > 0">
      <span class="sr-only" role="status">{{listado.length}} resultados encontrados, navegar con flechas"</span>
      <ul>
        <li *ngFor="let item of listado">
          <a #itemsR *ngIf="listado.length <= 1" id="unicoResultado" class="content-item-search-general text-2"
            [routerLink]="item.url" routerlinkactive="active" tabindex="-1" (click)="openItem(item)">{{
            item.nombreRecurso }}</a>
          <a #itemsR *ngIf="listado.length > 1" class="content-item-search-general text-2" [routerLink]="item.url"
            routerlinkactive="active" tabindex="-1" (click)="openItem(item)">{{ item.nombreRecurso }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>
